import { Button, Card, Checkbox, Form, Space, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { updateUserDetails } from "../../redux/slices/userSlice";
import GuestPageLayout from "../../layout/guestPageLayout";
import { Terms } from "../../redux/models/terms";

const { Title, Text, Link } = Typography;

export const TermsAcceptance = () => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const initialValues = {
    isTermsAccepted: false,
  };

  const onFinish = async () => {
    setLoading(true);

    try {
      await Terms.accept(false);
      dispatch(updateUserDetails({ isTermsAccepted: true }));
    } catch (error) {
      console.error("Error accepting terms of use:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTermsOfUse = async () => {
    try {
      const { data } = await Terms.getUrl();
      window.open(data.url, "_blank");
    } catch (error) {
      console.error("Error fetching terms of use:", error);
    }
  };

  return (
    <GuestPageLayout>
      <Space
        size="middle"
        direction="vertical"
        style={{ textAlign: "center", width: 500 }}
      >
        <div>
          <Title style={{ fontSize: 20, fontWeight: 500 }}>
            Get Started with Acumen
          </Title>
          <Text type="secondary">
            To access the platform, you must review and accept our Terms of Use.
          </Text>
        </div>
        <Card bodyStyle={{ padding: 20 }}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <div>
              <Title level={2} style={{ fontSize: 20, fontWeight: 500 }}>
                Terms of Use
              </Title>
              <Text type="secondary">
                Please review the{" "}
                <Link onClick={getTermsOfUse} underline>
                  Terms of Use
                </Link>{" "}
                before continuing. <br /> Your acceptance is required to
                proceed.
              </Text>
            </div>
            <Form form={form} initialValues={initialValues} onFinish={onFinish}>
              <Space
                direction="vertical"
                size="middle"
                style={{ width: "100%" }}
              >
                <Form.Item
                  name="isTermsAccepted"
                  valuePropName="checked"
                  style={{ margin: 0 }}
                >
                  <Checkbox>
                    I acknowledge that I have read and agree to the Terms of Use
                  </Checkbox>
                </Form.Item>
                <Form.Item shouldUpdate style={{ margin: 0 }}>
                  {({ getFieldValue }) => (
                    <Button
                      type="primary"
                      onClick={form.submit}
                      loading={loading}
                      disabled={!getFieldValue("isTermsAccepted")}
                      block
                    >
                      Agree and Continue
                    </Button>
                  )}
                </Form.Item>
              </Space>
            </Form>
          </Space>
        </Card>
      </Space>
    </GuestPageLayout>
  );
};
